export const getMaterial = state => state.dataSheet.materialList;

export default {
	getMaterial,
};
